/**************************************************
 * Nombre:       Tarjeta_Anuncio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import imange from '../../Recursos/tmp_anuncio.png'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Anuncio = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: 'linear-gradient(90deg, #96E9FB 0%, #5053F6 100%)',
                borderRadius: sCell ? 4 : 8,
                p: !masSM ? 2 : 8,
                overflow: 'hidden',


            }}
            spacing={1}
        >

            <Grid container size={{xs: 6, sm: 6, md: 7}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={0}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{color: '#2A7CC7', fontSize: !masSM ? 12 : 18, fontWeight: 600}}>Agosto
                            2026</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{color: '#252B42', fontSize: !masSM ? 22 : 62, fontWeight: 800, lineHeight: 1}}>
                            Hasta 50% de
                            descuento </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: sCell ? 1 : 2}}>
                        <Typography
                            sx={{color: '#505050', fontSize: !masSM ? 12 : 18, fontWeight: 400, lineHeight: 1.2}}>Cuidar
                            de ti es
                            nuestra
                            prioridad. Descubre
                            nuestras ofertas en productos seleccionados.</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: !masSM ? 2 : 4}}>
                        <Button
                            sx={{
                                color: '#fff',
                                borderRadius: 20,
                                fontSize: !masSM ? 12 : 14,
                                pt: !masSM ? 1.2 : 1.4,
                                pb: !masSM ? 1 : 1.2,
                                px: !masSM ? 2 : 4
                            }}>Comprar
                            Ahora</Button>
                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 5}} sx={{justifyContent: 'flex-start', mb: !masSM ? -2 : -8}}>
                <img src={imange} width={!masSM ? '135%' : '125%'} height={'auto'}/>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Anuncio    